import { graphql } from '@/gql'
import { useQuery } from '@apollo/client/react'
import { Button } from '../base/button'

const TestExecutionQuery = graphql(`
  query TestExecution($id: ID!) {
    testExecutions(filters: { idEq: $id }) {
      nodes {
        id
        equipment { id name }
        item { id name}
      }
    }
  }
`)

interface Props {
  id: string
}

export const TestExecution = ( { id }: Props) => {
  const { data } = useQuery(TestExecutionQuery, { variables: { id } })

  if (!data) return <></>

  const testExecution =  data.testExecutions.nodes[0]

  return(
    <div className='flex flex-row gap-3'>
      <Button color="purple" href={`/items/${testExecution.item.id}`}>Item ({testExecution.item.name})</Button>
      <Button color="purple" href={`/equipment/${testExecution.equipment.id}`}>Equipment ({testExecution.equipment.name})</Button>
    </div>
  )
}
